import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';

import { Styled } from './generic-error.styles';

export type GenericErrorType = {
  refetch: () => void;
};

export const GenericError: React.FC<GenericErrorType> = ({ refetch }) => (
  <Styled.Wrapper>
    <Styled.IllustrationSpotError />
    <Styled.Headline size="xlarge" sizeConfined="xxlarge">
      <FormattedMessage id="EP_ERROR_HEADER" />
    </Styled.Headline>
    <Styled.BodyCopy>
      <FormattedMessage id="EP_ERROR_BODY" />
    </Styled.BodyCopy>
    <Button onClick={() => refetch()} variant="tertiary">
      <FormattedMessage id="MOVEON_GENERIC_ERROR_CTA" />
    </Button>
  </Styled.Wrapper>
);
